import React from 'react';
import styles from './podcastSec.module.css';
import {
    podcastCardIcon1,
    podcastCardIcon2,
    podcastCardIcon3,
    podcastCardIcon4,
    podcastCardIcon5,
} from '../../../assets';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import { Link } from 'react-router-dom';
import { IMAGE_URL } from '../../helpers/api_helper.jsx';
import i18n from '../../../i18n.js';
import { LANG_AR } from '../../helpers/constant.jsx';

const PodcastCard = ({ image, ep, title, content, platforms }) => {
    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useTextAnimation();
    return (
        <div className={styles.pcCardSec}>
            <div className={`${styles.pcCardSecTop} ${i18n.language=== LANG_AR? 'arab':''}`}>
                <div className={styles.pcCardSecTopLft}>
                    {/*  <img src={image} alt="Podcast Thumbnail" /> */}
                    <img src={`${IMAGE_URL}/episode/${image}`} alt="" />
                </div>
                <div className={styles.pcCardSecTopRgtP}>
                    <div className={styles.pcCardSecTopRgt}>
                        <div className={styles.pcCardSecTopRgtT}>
                            <div className={styles.pcCardSecTopRgtTImg}>
                                <img src={podcastCardIcon1} alt="Icon" />

                            </div>
                            <div className={styles.pcCardSecTopRgtTEp}>
                                <h3>
                                    Episode <span>{ep}</span>
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className={styles.pcCardSecBotRgt}>
                        <h3>Watch Episode</h3>
                        <div className={styles.pcCardSecBotRgtIcons}>
                            {platforms.map(
                                (platform, index) => (

                                    <Link to={platform?.url} key={index} target="_blank" rel="noopener noreferrer">
                                        {/* <img src={icon} alt={`Icon ${index + 1}`} /> */}
                                         <img src={`${IMAGE_URL}/episode/${platform.icon}`} alt="" />
                                    </Link>
                                )
                            )}
                        </div>


                       {/*  <div className={styles.pcCardSecBotRgtIcons}>
                            {youtubeUrl &&
                                <Link to={youtubeUrl} target="_blank" rel="noopener noreferrer">
                                    <img src={podcastCardIcon2} alt={`Icon`} />
                                </Link>
                            }
                            {url &&
                                <Link to={url} target="_blank" rel="noopener noreferrer">
                                    <img src={podcastCardIcon5} alt={`Icon`} />
                                </Link>
                            }
                        </div> */}
                    </div>
                </div>
            </div>
            <div className={`${styles.pcCardSecBot} ${i18n.language===LANG_AR? 'arabText':''}`}>
                <motion.h3
                    ref={headingRef}
                    initial="hidden"
                    animate={headingInView ? "visible" : "hidden"}
                    custom={1}
                    variants={textAnimation}
                >{title}</motion.h3>
                <motion.p
                    ref={paragraphRef}
                    initial="hidden"
                    animate={paragraphInView ? "visible" : "hidden"}
                    custom={2}
                    variants={textAnimation}
                    dangerouslySetInnerHTML={{ __html: content }}
                ></motion.p>
            </div>
        </div>
    );
};

export default PodcastCard;
